import axios from 'axios';
export const makeTDAClient = ({ httpProvider, makeUrl, getToken, setToken, deleteToken }) => {
    return {
        httpProvider,
        session: {
            getToken,
            setToken,
            deleteToken
        },
        health: () => axios.get(makeUrl('/api/v1/health')),
        getClientPrivateKey: () => httpProvider.get(makeUrl('/api/v1/security/tests/client')),
        getTdaPublicKey: () => httpProvider.get(makeUrl('/api/v1/security/tests/server')),
        uploadBigQueryEvent: (eventData) => {
            return httpProvider.post(makeUrl('/api/v1/analytics/events'), eventData);
        },
        getExam: () => httpProvider.get(makeUrl('/api/v1/tests/definition')),
        setExamStatus: (status, statusDetails, callId) => {
            const statusPayload = { status, statusDetails };
            return httpProvider.post(makeUrl(`/api/v1/tests/calls/${callId}/status`), statusPayload);
        },
        endExam: (callId) => {
            return httpProvider.post(makeUrl(`/api/v1/tests/calls/${callId}/end`), {
                endedAt: new Date().toISOString(),
                status: 'COMPLETED',
                statusDetails: 'Exam finished successfully.'
            });
        },
        abortExam: (callId, reason) => {
            return httpProvider.post(makeUrl(`/api/v1/tests/calls/${callId}/abort`), {
                endedAt: new Date().toISOString(),
                statusDetails: reason
            });
        },
        hangupExam: (callId) => {
            return httpProvider.post(makeUrl(`/api/v1/tests/calls/${callId}/hangup`), {
                endedAt: new Date().toISOString()
            });
        },
        startExam: (localCall, telServer) => {
            return httpProvider.post(makeUrl('/api/v1/tests/start'), {
                localCall,
                telServer,
                startedAt: new Date().toISOString()
            }, { headers: { 'Content-Type': 'application/json' } });
        },
        getResource: async (url) => {
            const response = await httpProvider({
                url: url,
                method: 'GET',
                responseType: 'arraybuffer'
            });
            return response.data;
        },
        uploadResponse: (callId, examResponseId, formData) => {
            return httpProvider.postForm(makeUrl(`/api/v1/tests/calls/${callId}/responses/${examResponseId}`), formData);
        }
    };
};
//# sourceMappingURL=client.js.map